import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import ResourceItem from './ResourceItem';
import TextInput from '../../../../../Shared/TextInput/TextInput';
import { updateServiceNameAsync } from '../../../BusinessMonitoringChartsAsyncThunk';

const ServiceItem = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const hasChildren = props.item.resources?.length > 0;
    const [isEditMode, setIsEditMode] = useState(false);
    const [serviceCode, setServiceCode] = useState(props.item.serviceCode);

    useEffect(() => {
        if(!!props.selectedItem && props.selectedItem != props.item.serviceCode) {
            setIsOpen(false);
        }
    },[props.selectedItem]);

    return (
        <>
            <div className='service-item-wrapper'>     
                {
                    isEditMode ? (
                        <>
                            <form className='text-and-edit-wrapper' noValidate id='service-item' onSubmit={(e)=> e.preventDefault()}>
                                <div className='service-field'>
                                    <TextInput
                                        value={serviceCode}
                                        error={''}
                                        placeholder={''}
                                        id='txt-search'
                                        name='txt-search'
                                        type='text'
                                        maxLength='40'
                                        autoComplete='off'
                                        onChange={(e) => setServiceCode(e.target.value)}
                                    />                            
                                </div>
                                <button type='submit' className='vi-icon' onClick={(e)=> handleSaveServiceCodeClick(e)} />
                            </form>    
                            <a className='close-edit-mode' href='#' onClick={(e)=> handleCloseEditMode(e)}></a>                   
                        </>
 
                    ) : (
                        <>
                            <div className='text-and-edit-wrapper'>
                                <a className='text-wrapper' href='#' onClick={(e)=> handleItemClick(e, props.item)}>
                                    <span>{serviceCode}</span>
                                </a> 
                                {
                                    !props.isAdminMode &&
                                    <a className='edit-service' href='#' onClick={(e)=> {e.preventDefault(); setIsEditMode(true)}}></a> 
                                }                                
                            </div>
                            {
                                hasChildren &&
                                <span className={isOpen ? 'arrow-up-icon' : 'arrow-down-icon'}></span>
                            }                        
                        </>
                    )
                  
                }                            
            </div>  

            {
                hasChildren && isOpen &&
                <div className='item-list-wrapper'>
                    {
                        props.item.resources?.map((resource, index) => {
                            return <ResourceItem key={index} item={resource} /> 
                        })
                    } 
                </div>
            }        
        </>
    );


    function handleItemClick(e, item) {
        e.preventDefault();

        if (hasChildren) {
            if (!isOpen) {
                props.setSelectedItem(item.serviceCode);
            }
            setIsOpen(!isOpen);
        }      
    } 

    function handleCloseEditMode(e) {
        e.preventDefault();
        setIsEditMode(false);    
        setServiceCode(props.item.serviceCode);    
    }   

    function handleSaveServiceCodeClick(e) {
        e.preventDefault();
        setIsEditMode(false); 

        const data = {
            nvId: props.item?.nvId,         
            serviceCode: props.item?.serviceCode,            
            serviceName: serviceCode
        };
        props.updateServiceNameAsync(data);      
    } 

};

const mapStateToProps = (state) => {
    return {
        isAdminMode: state.businessMonitoringChartsBlock.isAdminMode
    };
};
  
const mapDispatchToProps = { updateServiceNameAsync };
  
export default connect(mapStateToProps, mapDispatchToProps)(ServiceItem);